module.exports = __webpack_public_path__ + "img/instagram.1225f22.svg";